import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { ConnectedApp } from './App';
import store from './store';
import { Provider } from 'react-redux';
import { history } from './store/store';
import { ConnectedRouter } from 'connected-react-router';

import { CookiesProvider } from 'react-cookie';

import { SENTRY_DSN } from './constants/login';
import './i18n';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { AnalyticsHandlersProvider } from './analytics/__providers__/AnalyticsHandlersProvider';
import { FeatureFlagProvider } from './components/__providers__/FeatureFlagsContext';

const hack: any = undefined;
Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  beforeSend(event) {
    return event;
  },
  tracesSampleRate: 1.0,
});
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <AnalyticsHandlersProvider>
    <Provider store={store}>
      <CookiesProvider>
        <FeatureFlagProvider>
          <ConnectedRouter history={history}>
            <ConnectedApp {...hack} />
          </ConnectedRouter>
        </FeatureFlagProvider>
      </CookiesProvider>
    </Provider>
  </AnalyticsHandlersProvider>,
);
